<template>
  <div class="d-flex justify-content-between flex-wrap pt-0">
    <p class="text-nowrap align-left">
      &nbsp;Total Rows {{ totalRows }}
    </p>
    <b-form-group
      label="Per Page"
      label-cols="6"
      label-align="left"
      label-size="sm"
      label-for="sortBySelect"
      class="text-nowrap mb-md-0 mr-1"
    >
      <b-form-select
        id="perPageSelect"
        v-model="perPageComputed"
        size="sm"
        inline
        :options="pageOptions"
        @change="onPerPageChange"
      />
    </b-form-group>
    <p class="text-nowrap mb-md-0 mr-1 align-left" />
    <!-- pagination -->
    <div>
      <b-pagination
        v-model="currentPageComputed"
        :total-rows="totalRows"
        :per-page="perPageComputed"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @input="filterz"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </div>
  </div>
</template>
<script>
import { BFormGroup, BFormSelect, BPagination } from 'bootstrap-vue'

export default {
  name: 'Pagination',
  components: { BFormGroup, BFormSelect, BPagination },
  props: {
    totalRows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageOptions: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
  },
  computed: {
    currentPageComputed: {
      get() {
        return this.currentPage
      },
      set(value) {
        this.$emit('update:currentPage', value)
      },
    },
    perPageComputed: {
      get() {
        return this.perPage
      },
      set(value) {
        this.$emit('update:perPage', value)
      },
    },
  },
  methods: {
    filterz(val) {
      this.$emit('filter', val, this.perPageComputed)
    },
    onPerPageChange() {
      const firstPage = 1
      this.currentPageComputed = firstPage
      if (this.currentPageComputed == 1) {
        this.filterz(firstPage)
      }
    },
  },
}
</script>
